import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const MoreOptionsWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  gap: 2,
}));

export const CurrentOptionsWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  height: "100%",
  gap: 5,
}));

const styles = makeStyles(() => ({
  wrapper: {
    display: "flex",
    alignItems: "center",
  },
  optionsBadge: {
    "& .MuiBadge-badge": {
      backgroundColor: colors.brandBlue400,
      color: "#fff",
      font: "700 6px/7px Inter",
      minWidth: 8,
      width: 8,
      height: 11,
      zIndex: 0,
    },
  },
  optionsButton: {
    color: colors.brandBlue400,
    backgroundColor: colors.brandBlue25,
    borderRadius: 4,
    width: 16,
    height: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  moreOrdersList: {
    "& .MuiMenu-paper": {
      padding: "8px 16px",
      borderRadius: 12,
      boxShadow:
        "2px 1px 5px rgba(152, 162, 179, 0.15), 0px 4px 10px rgba(48, 140, 219, 0.05) !important",
      width: "inherit",
      "& label": {
        color: colors.brandBlue400,
        font: "600 12px/24px Manrope",
      },
      "& span": {
        color: "#667085",
        font: "600 12px/18px Manrope",
      },
    },
  },
  singleOptionPerLine: {
    whiteSpace: "pre-line",
  },
}));

export default styles;
